import { getGlobalConfig } from '@dealstack/frontend/shared/globalConfig';
import fileDownload from 'js-file-download';

const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
function base64ToBytes(base64: string): Uint8Array {
	const binString = window.atob(base64);
	return Uint8Array.from(binString, (m) => m.codePointAt(0) as number);
}

export const downloadFileFromBlob = (blob: Blob, fileName: string): void => {
	const downloadLink = document.createElement('a');
	downloadLink.href = window.URL.createObjectURL(blob);
	const isFileNameIsBase64 = base64regex.test(fileName);
	downloadLink.download = isFileNameIsBase64
		? new TextDecoder().decode(base64ToBytes(fileName))
		: fileName;
	downloadLink.click();
};

export const downloadFileFromAssets = (url: string): void => {
	const globalConfig = getGlobalConfig();
	const downloadLink = document.createElement('a');
	downloadLink.href = `${globalConfig.assetsUrl}${url}`;
	downloadLink.download = url.split('/').pop() ?? 'file';
	downloadLink.target = '_blank';
	downloadLink.click();
};

export const downloadFileFromAssetsDirectly = async (
	url: string,
	filename: string
): Promise<void> => {
	const globalConfig = getGlobalConfig();
	const response = await fetch(`${globalConfig.assetsUrl}${url}`);
	if (response.body) {
		fileDownload(await response.arrayBuffer(), filename);
	}
};

/**
 * Saves a cross-origin file (e.g. a presigned S3 URL) under `fileName`. Browsers ignore
 * `download` on cross-origin links, so the file is fetched as a blob first; if that fails
 * it falls back to the plain link and the server-provided name.
 */
export const downloadUrlAsFile = async (downloadUrl: string, fileName: string): Promise<void> => {
	try {
		const response = await fetch(downloadUrl);
		if (!response.ok) {
			throw new Error(`Download failed with status ${response.status}`);
		}
		downloadFileFromBlob(await response.blob(), fileName);
	} catch {
		downloadFileTrigger(downloadUrl, fileName);
	}
};

export const downloadFileTrigger = (downloadUrl: string, fileName?: string) => {
	const link = document.createElement('a');
	link.href = downloadUrl;
	link.download = fileName ?? '';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
